export const clientTestimonials = [
  {
    id: 1,
    name: "Omer Abdulla",
    role: "Real Estate Client, Dubai (UAE)",
    quote:
      "Oglitz helped us build a strong digital presence with a clean, modern website that perfectly represents our real estate brand in Dubai.",
  },
  {
    id: 2,
    name: "Reema Steel",
    role: "Kitchen Equipment & Steel Fabrication, Dubai",
    quote:
      "Professional execution and timely delivery. Our corporate website now clearly showcases our industrial capabilities.",
  },
  {
    id: 3,
    name: "Ardh Al Safari",
    role: "Real Estate Company, Dubai",
    quote:
      "Excellent coordination and execution. The website delivered by Oglitz helped us improve client inquiries.",
  },
  {
    id: 4,
    name: "Abraj Real Estate",
    role: "Property Brokerage, Dubai",
    quote:
      "Modern design, smooth performance, and a highly professional development experience.",
  },
  {
    id: 5,
    name: "Bharat Jalpan",
    role: "Restaurant Business, Dubai",
    quote:
      "Oglitz gave our brand a professional digital identity that truly reflects our restaurant business.",
  },
  // {
  //   id: 6,
  //   name: "Burj Al Yarmouk Industries",
  //   role: "Industrial Manufacturing Client, Dubai",
  //   quote:
  //     "Strong technical understanding and enterprise-level execution for our industrial website.",
  // },
  {
    id: 7,
    name: "Trio Line Real Estate",
    role: "Real Estate Firm, Dubai",
    quote:
      "Clean UI, fast loading, and excellent lead inquiry integration. Highly satisfied.",
  },
  {
    id: 8,
    name: "Trippr",
    role: "Vehicle Rental Startup, India",
    quote:
      "Oglitz played a key role in shaping our platform and delivering a smooth user experience.",
  },
  {
    id: 9,
    name: "Nautika",
    role: "Online Ferry Booking Platform, India",
    quote:
      "Reliable development partner with a strong focus on scalability and performance.",
  },
  {
    id: 10,
    name: "Octavian GR",
    role: "Enterprise Client, United Kingdom",
    quote:
      "Professional, secure, and enterprise-ready development. The collaboration was smooth and efficient.",
  },
  {
    id: 11,
    name: "Confidential Client",
    role: "NDA Project, Germany",
    quote:
      "Handled with complete confidentiality and delivered a robust, scalable solution.",
  },
  {
    id: 12,
    name: "Foxey",
    role: "Video Streaming Platform, Ahmedabad",
    quote:
      "Excellent performance optimization and a very smooth streaming experience delivered.",
  },
  {
    id: 13,
    name: "Mr Gekonge",
    role: "Social Media App Client, Kenya",
    quote:
      "Oglitz understood our vision and delivered a scalable social media application.",
  },
  {
    id: 14,
    name: "Welth Clinic",
    role: "Real Estate Channel Partner, Lucknow",
    quote:
      "The website helped us generate quality leads and improve our online presence.",
  },
  {
    id: 15,
    name: "Fibble",
    role: "Government Affiliated Project, Punjab",
    quote:
      "Structured approach and strong technical delivery for a government-scale project.",
  },
  {
    id: 16,
    name: "Maya",
    role: "Business Client, Bahrain",
    quote:
      "Professional team with a modern approach to web and application development.",
  },
  {
    id: 17,
    name: "Ahmed Hady",
    role: "International Client, Egypt",
    quote:
      "Clear communication, timely delivery, and high-quality development standards.",
  },
  {
    id: 18,
    name: "Crypto App Client",
    role: "Blockchain Startup, USA",
    quote:
      "Strong understanding of modern technologies and secure application development.",
  },
  {
    id: 19,
    name: "John Madia",
    role: "Business Client, Brazil",
    quote:
      "Efficient delivery with great technical support throughout the project lifecycle.",
  },
  {
    id: 20,
    name: "Nicolas Gou",
    role: "Technology Client, Lithuania",
    quote:
      "Clean architecture, smooth collaboration, and excellent final results.",
  },
];
